// Static recharts style objects, defined once to avoid creating new object
// references on every render (which forces child charts to re-render).

export const CHART_MARGIN = { top: 5, right: 10, bottom: 0, left: 0 };
export const TOOLTIP_STYLE = { borderRadius: 12, border: "1px solid #eee", fontSize: 12 };
export const TOOLTIP_STYLE_NUNITO = { borderRadius: 12, border: "1px solid #eee", fontSize: 12, fontFamily: "Nunito" };
export const TOOLTIP_LABEL = { color: "#64748b" };
export const LEGEND_STYLE = { fontSize: 12, paddingTop: 8 };

export const TICK_MICRO = { fontSize: 9, fill: "#cbd5e1" };
export const TICK_MINI = { fontSize: 10, fill: "#cbd5e1" };
export const TICK_AXIS = { fontSize: 11, fill: "#94a3b8" };

export const DOT_SM = { r: 3 };
export const DOT_BLUE = { r: 3, fill: "#6C8EBF" };
export const DOT_GREEN = { r: 3, fill: "#5d8a73" };

export const DOMAIN_0_45 = [0, 45];

// Seed dimensions for ResponsiveContainer (read once on mount) — shared to avoid
// allocating a new object literal on every render.
export const INIT_DIM_LG = { width: 300, height: 256 };
export const INIT_DIM_MD = { width: 300, height: 96 };
export const INIT_DIM_SM = { width: 300, height: 80 };
